import { categoryMapping } from './constants.ts';
import type { TranslateFn } from './types.ts';

/**
 * Get a translated category label for accessibility purposes.
 * Returns a translation key for known categories based on the official category schema.
 * @param {string} category - The category ID (e.g., "eat.restaurant", "services.rentalcar")
 * @param {function} T - Translation function
 * @returns {string} Translated category label or empty string for fallback to name-only
 */
export const getCategoryLabel = (category: string | undefined, T: TranslateFn) => {
  if (!category) {
    return '';
  }

  // Check for exact match first (e.g., 'element.door'), then fallback to main category
  const mainCategory = category.split('.')[0];
  const translationKey =
    categoryMapping[category as keyof typeof categoryMapping] ||
    categoryMapping[mainCategory as keyof typeof categoryMapping];

  return translationKey ? T(translationKey) : '';
};
